export const FULL_WORKDAY_IN_SECONDS = 8 * 3600;
